"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var time_1 = require("../../../../../common/helpers/time");
var saveToDisk_1 = require("../../../../../common/helpers/saveToDisk");
var splitFormDataByFile_1 = require("../../../../../common/helpers/splitFormDataByFile");
var permitImages_1 = require("../../../../../common/helpers/permitImages");
var AdminStudentEditPermitController = /** @class */ (function () {
    function AdminStudentEditPermitController($state, $stateParams, UsersModel, FlashService, PermitModel, permitData, FilesModel, AuthService, APPURL, $q) {
        var _this = this;
        this.initialLoad = true;
        this.loading = true;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.PermitModel = PermitModel;
        this.AuthService = AuthService;
        this.FlashService = FlashService;
        this.submitted = false;
        this.stateRequiresPermit = false;
        this.FilesModel = FilesModel;
        this.files = permitData.files;
        this.$q = $q;
        this.permit = {
            number: "",
            issue_date: "",
            expiration_date: "",
        };
        this.handlePermitFrontUpload = this.handlePermitFrontUpload.bind(this);
        this.handlePermitBackUpload = this.handlePermitBackUpload.bind(this);
        PermitModel.getPermit($stateParams.userId).then(function (response) {
            _this.files = response.files;
            var permitData = response;
            if (permitData.permit.number) {
                _this.permit.number = permitData.permit.number;
            }
            if (permitData.permit.issuedate) {
                _this.permit.issue_date = (0, time_1.dateStringToDate)(permitData.permit.issuedate);
            }
            if (permitData.permit.expirationdate) {
                _this.permit.expiration_date = (0, time_1.dateStringToDate)(permitData.permit.expirationdate);
            }
            _this.loading = false;
        });
        this.updateIssueDate = this.updateIssueDate.bind(this);
        this.updateExpirationDate = this.updateExpirationDate.bind(this);
    }
    AdminStudentEditPermitController.prototype.getPermit = function (id) {
        return this.PermitModel.getPermit(id).then(function (response) {
            return response;
        });
    };
    AdminStudentEditPermitController.prototype.formatDate = function (datestring) {
        return new Date(datestring).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    AdminStudentEditPermitController.prototype.deleteFile = function (id) {
        var _this = this;
        this.FilesModel.destroy(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.files = _this.files.filter(function (file) {
                return file.id !== id;
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong deleting the file.",
            });
        });
    };
    AdminStudentEditPermitController.prototype.downloadFile = function (id) {
        var _this = this;
        this.FilesModel.get(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.temporary_url);
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong downloading the file.",
            });
        });
    };
    AdminStudentEditPermitController.prototype.frontImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_FRONT_TYPE);
    };
    AdminStudentEditPermitController.prototype.backImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_BACK_TYPE);
    };
    AdminStudentEditPermitController.prototype.handlePermitFrontUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_FRONT_TYPE);
    };
    AdminStudentEditPermitController.prototype.handlePermitBackUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_BACK_TYPE);
    };
    AdminStudentEditPermitController.prototype.uploadPermitImage = function (formData, fileType) {
        var _this = this;
        var uploads = (0, splitFormDataByFile_1.splitFormDataByFile)(formData).map(function (singleFileFormData) {
            singleFileFormData.append("students", JSON.stringify([_this.$stateParams.userId]));
            return _this.FilesModel.uploadFile(fileType, fileType, singleFileFormData);
        });
        this.$q
            .all(uploads)
            .then(function (responses) {
            responses.forEach(function (response) {
                _this.files.push(response.file);
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong uploading the file.",
            });
        });
    };
    AdminStudentEditPermitController.prototype.updateIssueDate = function (newDate) {
        this.permit.issue_date = newDate.selected[0];
    };
    AdminStudentEditPermitController.prototype.updateExpirationDate = function (newDate) {
        this.permit.expiration_date = newDate.selected[0];
    };
    AdminStudentEditPermitController.prototype.updatePermit = function () {
        var _this = this;
        this.submitted = true;
        var permit = {
            number: this.permit.number,
            issue_date: (0, time_1.toYMDOrEmpty)(this.permit.issue_date),
            expiration_date: (0, time_1.toYMDOrEmpty)(this.permit.expiration_date),
        };
        this.PermitModel.update(this.$stateParams.userId, permit)
            .then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.admin.students.view", { userId: _this.$stateParams.userId }, { reload: true });
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return AdminStudentEditPermitController;
}());
AdminStudentEditPermitController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "PermitModel",
    "permitData",
    "FilesModel",
    "AuthService",
    "APPURL",
    "$q",
];
exports.default = AdminStudentEditPermitController;
